// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"e6b8d87d","550":"366a87b0","626":"d0fbecc4","683":"8e7f0600","777":"77098d42","830":"5f520353","958":"0dca0cb0"}[chunkId] + ".js";
};